module.exports = __webpack_public_path__ + "static/media/SealCheck.d4e00238.svg";